<div class="modal-body">
    <div class="content" *ngIf="!loading.getData">
        <div class="content__top">
            <h4 translate>company.dids.verification-data.popup.title</h4>
            <button type="button" class="close" aria-label="Close" (click)="close()">
                <i class="icon-small-close"></i>
            </button>
        </div>
        <div class="content__form" [formGroup]="form">
            <div class="form-group">
                <label for="verification-data-label" translate>company.dids.verification-data.popup.form.label.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': isFieldValid('label')
                  }">
                    <input class="vox-text-field" type="text" id="verification-data-label"
                        formControlName="label"
                        [placeholder]="'company.dids.verification-data.popup.form.label.placeholder' | translate"><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message"
                        translate>company.dids.verification-data.popup.form.error.required</span>
                </div>
            </div>
            <div class="form-group">
                <label for="verification-data-description" translate>company.dids.verification-data.popup.form.description.label</label>
                <textarea class="vox-text-field"
                type="text" id="verification-data-description"
                style="height: unset;"
                formControlName="description"
                [placeholder]="'company.dids.verification-data.popup.form.description.placeholder' | translate"></textarea>
            </div>
            <div class="form-group">
                <label for="verification-data-type" translate>company.dids.verification-data.popup.form.type.label</label>
                <div ngbDropdown class="dropdown">
                    <button class="dropdown__btn"
                      id="verification-data-type"
                      ngbDropdownToggle>
                      <span>{{getType.label | translate}}</span>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="verification-data-type">
                      <button *ngFor="let type of availableTypes"
                      ngbDropdownItem
                      class="dropdown__item"
                      (click)="selectType(type)"><span translate>{{type.label}}</span></button>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="verification-data-company-name" translate>company.dids.verification-data.popup.form.company-name.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': isFieldValid('companyName')
                  }">
                    <input class="vox-text-field" type="text" id="verification-data-company-name"
                        formControlName="companyName"
                        [placeholder]="'company.dids.verification-data.popup.form.company-name.placeholder' | translate"><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message"
                        translate>company.dids.verification-data.popup.form.error.required</span>
                </div>
            </div>
            <div class="form-group">
                <label for="verification-data-vat-number" translate>company.dids.verification-data.popup.form.vat-number.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': invalidVat
                  }">
                <vox-vat-field [defaultVat]="defaultCountry" [dense]="true" formControlName="vat"
                placeholder="{{'company.number.form.vat.placeholder' | translate}}"
                (isFocus)="onCheckVatErrors($event)">
                </vox-vat-field>
                <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
                <span class="vox-input-group__error-message" translate>company.dids.verification-data.popup.form.error.required</span>
                </div>
            </div>
            <div *ngIf="getType.value === 'private'" class="form-group">
                <label for="verification-data-first-name" translate>company.dids.verification-data.popup.form.first-name.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': isFieldValid('firstName')
                  }">
                    <input class="vox-text-field" type="text" id="verification-data-first-name"
                        formControlName="firstName"
                        [placeholder]="'company.dids.verification-data.popup.form.first-name.placeholder' | translate"><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message"
                        translate>company.dids.verification-data.popup.form.error.required</span>
                </div>
            </div>
            <div *ngIf="getType.value === 'private'" class="form-group">
                <label for="verification-data-last-name" translate>company.dids.verification-data.popup.form.last-name.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': isFieldValid('lastName')
                  }">
                    <input class="vox-text-field" type="text" id="verification-data-last-name"
                        formControlName="lastName"
                        [placeholder]="'company.dids.verification-data.popup.form.last-name.placeholder' | translate"><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message"
                        translate>company.dids.verification-data.popup.form.error.required</span>
                </div>
            </div>
            <div *ngIf="getType.value === 'private'" class="form-group">
                <label for="verification-data-birth-place" translate>company.dids.verification-data.popup.form.birth-place.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                     'vox-input-group_invalid': isFieldValid('birthPlace')
                    }">
                    <input class="vox-text-field" type="text" id="verification-data-birth-place"
                        formControlName="birthPlace"
                        [placeholder]="'company.dids.verification-data.popup.form.birth-place.placeholder' | translate"><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message"
                        translate>company.dids.verification-data.popup.form.error.required</span>
                </div>
            </div>
            <div *ngIf="getType.value === 'private'" class="form-group">
                <label for="date" translate>company.dids.verification-data.popup.form.birth-date.label</label>
                <div class="vox-input-group vox-input-group_dense"
                    [ngClass]="{'vox-input-group_invalid': isFieldValid('date')}">
                    <div class="date-picker-container">
                        <gdp-date-picker formControlName='date' [maxDate]="startDay" [minDate]="minDate"></gdp-date-picker>
                    </div>
                    <span class="vox-input-group__error-message" *ngIf="form.get('date').errors?.required"
                        translate>company.dids.verification-data.popup.form.error.required</span>
                </div>
            </div>
            <div *ngIf="getType.value === 'private'" class="form-group">
                <label for="verification-data-nationality" translate>company.dids.verification-data.popup.form.nationality.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': isFieldValid('nationality')
                    }">
                    <input class="vox-text-field" type="text" id="verification-data-nationality"
                        formControlName="nationality"
                        [placeholder]="'company.dids.verification-data.popup.form.nationality.placeholder' | translate"><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message"
                        translate>company.dids.verification-data.popup.form.error.required</span>
                </div>
            </div>
            <div class="form-group">
                <label for="verification-data-email" translate>company.dids.verification-data.popup.form.email.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': isFieldValid('email')
                     }">
                    <input class="vox-text-field" type="email" id="verification-data-email"
                        formControlName="email"
                        [placeholder]="'company.dids.verification-data.popup.form.email.placeholder' | translate"><i
                        class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                        class="vox-input-group__error-message" *ngIf="form.get('email').errors && form.get('email').errors.required"
                        translate>company.dids.verification-data.popup.form.error.required</span><span
                        class="vox-input-group__error-message" *ngIf="form.get('email').errors && form.get('email').errors.pattern"
                        translate>company.dids.verification-data.popup.form.email.error-pattern</span>
                </div>
            </div>
            <div class="form-group">
                <label for="verification-data-phone" translate>company.dids.verification-data.popup.form.phone.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': phoneValidation()
                    }">
                    <vox-phone-text-field state="it" formControlName="phone" [dense]="true"></vox-phone-text-field>
                        <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
                        <span class="vox-input-group__error-message"
                        translate>company.dids.verification-data.popup.form.phone.error-pattern</span>
                </div>
            </div>
            <div class="form-group mb-5">
                <label for="verification-data-address" translate>company.dids.verification-data.popup.form.address.label</label>
                <div class="vox-input-group vox-input-group_dense" [ngClass]="{
                    'vox-input-group_invalid': isFieldValid('address')
                    }">
                    <vox-address-search formControlName="address"
                    [googleKey]="googleKey"
                    [placeholder]="'company.dids.verification-data.popup.form.address.placeholder' | translate">>
                    </vox-address-search>
                    <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
                    class="vox-input-group__error-message"
                    translate>company.dids.verification-data.popup.form.address.error-invalid</span>
                </div>
            </div>
            <div class="vox-inline-message vox-inline-message_light-grey" style="margin-bottom: 15px;">
                <div>
                  <i class="icon-small-info"></i>
                  <span [innerHTML]="'company.dids.verification-data.popup.form.documents.info' | translate"></span>
                </div>
            </div>
            <div class="form-group verification-data-documents">
                <h5 class="verification-data-documents__title" translate>company.dids.verification-data.popup.form.documents.title</h5>
                <div class="verification-data-documents__table">
                    <table>
                        <thead>
                            <tr>
                                <td translate>company.dids.verification-data.popup.form.documents.table.name.label</td>
                                <td translate>company.dids.verification-data.popup.form.documents.table.type.label</td>
                                <td translate>company.dids.verification-data.popup.form.documents.table.actions.label</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let name of documentsName; let i = index">
                                <td>
                                    <div class="vox-input-group vox-input-group_dense">
                                        <b class="box-name">{{name}}</b>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div ngbDropdown class="dropdown">
                                            <button class="dropdown__btn"
                                              id="verification-data-document-bill-type"
                                              ngbDropdownToggle>
                                              <span>{{'company.dids.verification-data.popup.form.documents.table.type.list.' + selectedDocsType[i] | translate}}</span>
                                            </button>
                                            <div ngbDropdownMenu aria-labelledby="verification-data-document-bill-type">
                                              <button ngbDropdownItem
                                              *ngFor="let type of availableDocTypes"
                                              (click)="selectDocType(i, type)"
                                              class="dropdown__item">
                                                  <span translate>company.dids.verification-data.popup.form.documents.table.type.list.{{type}}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="verification-data-documents__actions">
                                        <div>
                                            <div class="upload-zone">
                                              <label class="vox-btn upload-btn">
                                                <i class="icon-small-folder"></i>
                                                <input hidden
                                                type="file"
                                                ng2FileSelect [uploader]="docsUploader"
                                                (change)="selectedFileOnChanged($event, i)"/>
                                              </label>
                                            </div>
                                        </div>
                                        <button class="vox-btn btn-danger"
                                                (click)="removeFile(i)">
                                            <i class="icon-small-delete"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="verification-data-documents__add-new">
                        <button class="vox-btn vox-btn-secondary"
                        [disabled]="isAddNewDocDisabled()"
                        (click)="addNewDocument()" type="submit">
                            <span translate>company.dids.verification-data.popup.form.documents.buttons.add-new</span>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="checkVerificationDataList()" class="vox-inline-message vox-inline-message_light-grey">
                <div>
                  <i class="icon-small-alert"></i>
                  <span translate>{{getTranslationAlert() | translate}}</span>
                </div>
            </div>
            <div class="submit-container">
                <button class="vox-btn vox-btn-primary"
                type="submit" [disabled]="form.invalid || invalidVat || checkVerificationDataList()"
                (click)="createVrificationData()"
                [ladda]="loading.createData">
                <span translate>company.dids.verification-data.popup.form.submit-create</span>
                </button>
            </div>
        </div>
    </div>
    <div class="content" *ngIf="loading.getData">
        <ngx-skeleton-loader [theme]="{'height':'500px', 'outline': 'none'}"></ngx-skeleton-loader>
    </div>
</div>